import styled from "styled-components";

const Wrapper = styled.div`
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (min-width: ${({ theme }) => theme.breakpoints?.sm ?? 640}px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
`;

const TitleBlock = styled.div`
  flex: 1;
  min-width: 0;
`;

const Title = styled.h1`
  margin: 0;
  font-size: 28px;
  font-weight: 800;
  color: ${({ theme }) => theme.colors?.text?.heading ?? "#111827"};
`;

const Sub = styled.p`
  margin: 8px 0 0;
  font-size: 14px;
  color: ${({ theme }) => theme.colors?.text?.body ?? "#6b7280"};
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  flex-shrink: 0;
  margin-top: 8px;

  @media (min-width: ${({ theme }) => theme.breakpoints?.sm ?? 640}px) {
    margin-top: 0;
  }
`;

/**
 * Shared page header for dashboard pages.
 * @param {string} title - Page title
 * @param {string} [sub] - Optional subtitle/description
 * @param {React.ReactNode} [actions] - Optional right-side actions (buttons, etc.)
 */
export function PageHeader({ title, sub, actions }) {
  return (
    <Wrapper>
      <TitleBlock>
        <Title>{title}</Title>
        {sub && <Sub>{sub}</Sub>}
      </TitleBlock>
      {actions && <Actions>{actions}</Actions>}
    </Wrapper>
  );
}
